/** 돌아갈 곳을 모르겠으면 첫 화면으로 보낸다. */
const DEFAULT_PATH = '/';

/**
 * 사이트 안의 경로만 목적지로 인정한다 (오픈 리다이렉트 방지).
 *
 * `/` 로 시작하는지만 보면 부족하다 — `//evil.com` 과 `/\evil.com` 은 브라우저가
 * **다른 사이트**로 읽는다. 로그인·가입 직후의 이동이라 속으면 그대로 남의 사이트에 내려앉는다.
 *
 * 주소창(`?next=`)이든 저장소든, 사용자가 고칠 수 있는 곳에서 온 목적지는 전부 이 문을 지난다.
 */
export const toInternalPath = (value: unknown, fallback: string = DEFAULT_PATH): string => {
  if (typeof value !== 'string' || !value.startsWith('/')) {
    return fallback;
  }
  const second = value[1];
  return second === '/' || second === '\\' ? fallback : value;
};
